export default (keyCode, isHelpAndSupport, to, func) => {
    if (keyCode === 'Enter' && isHelpAndSupport) {
        func(to);
    }
};
